import axios from "axios";
// initial state
const state = {
  company: JSON.parse(localStorage.getItem("company")),
  profile_path: null,
};

// getters
const getters = {
  getCompany: (state) => state.company,
  getProfilePath: (state) => state.profile_path,
};

// actions
const actions = {
  GetCompany({ commit }, company_uuid) {
    return new Promise((resolve) => {
      axios({
        url: "/company/" + company_uuid,
        method: "GET",
      }).then((res) => {
        commit("setCompany", res.data.payload);
        localStorage.setItem("company", JSON.stringify(res.data.payload));
        // commit(
        //   "setProfilePath",
        //   `http://88.198.219.62/api_smsc/v1/file/${res.data.payload.contact.logo_file_uuid
        //   }`
        // );
        resolve(res.data.payload);
      });
    });
  },
  GetCompanyList({ commit }, list) {
    return new Promise((resolve) => {
      axios({
        url: "/company/list?order_by=created_on&order_dir=desc",
        params: {
          page: list && list.page ? list.page : "",
          company_name:
            list && list.company_name ? "*" + list.company_name + "*" : "",
          company_uuid: list.company_uuid || '',
          reseller_uuid: list.reseller_uuid || '',
          reseller_name: list && list.reseller ? list.reseller : "",
          is_below_credit_limit:
            list && list.is_below_credit_limit
              ? list.is_below_credit_limit
              : "",
          payment_term_uuid:
            list && list.paymentTermId ? list.paymentTermId : "",
          per_page: list && list.per_page ? list.per_page : 10000,
          status: list.is_active ? "active" : '',
          prepay: list.prepay
        },
        method: "GET",
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },
  GetOwnCompanyList({ commit }, list) {
    return new Promise((resolve) => {
      axios({
        url: "/company/list?order_by=created_on&order_dir=desc",
        params: {
          is_created_by_admin: true,
          per_page: list.perPage ? list.perPage : 10,
        },
        method: "GET",
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },
  AddCompany({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios({
        url: "company",
        data: company.company,
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  EditCompanyInfo({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios({
        url: "company/" + company.id,
        data: company.companyInfo,
        method: "PATCH",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  DeleteCompany({ commit }, id) {
    return new Promise((resolve) => {
      axios({
        url: "/company/" + id,
        params: { is_created_by_admin: true },
        method: "DELETE",
      }).then((res) => {
        resolve(res);
      });
    });
  },
  GetSmsLogList({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'log/report',
        params: {
          // group: 'sms_uuid,sms_time,user_id,company_name,ani,dnis,sms_content,sms_bulk,route_status,vendor_id,delivered',
          group: 'sms_uuid,sms_time,user_id,user_name,company_name,ani,dnis,sms_content,route_status,vendor_id,delivered,relay_dlr_content',
          start_time: list.start_time || null,
          end_time: list.end_time || null,
          count: list.per_page || 10,
          from: list.page || 0,
          dnis: list.dnis,
          ani: list.ani,
          sms_content: list.sms_content,
          user_id: list.user_id,
          user_name: list.user_name || null,
          company_name: list.company_name,
          vendor_id: list.vendor_id,
          order: list.order,
          sort: list.sort
        },
        method: 'GET'
      })
        .then(res => {
          resolve(res.data)
        })
    })
  },
  GetSmsLogListIncoming({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'log/mo_report',
        params: {
          group: 'user_id,user_name,sms_uuid,sms_time,company_name,ani,dnis,sms_content,vendor_id',
          start_time: list.start_time || null,
          end_time: list.end_time || null,
          count: list.per_page || 10,
          from: list.page || 0,
          dnis: list.dnis,
          ani: list.ani,
          sms_content: list.sms_content,
          user_id: list.user_id,
          user_name: list.user_name || null,
          company_name: list.company_name,
          vendor_id: list.vendor_id,
          order: list.order,
          sort: list.sort
        },
        method: 'GET'
      })
        .then(res => {
          resolve(res.data)
        })
    })
  }
};

// mutations
const mutations = {
  setCompany: (state, value) => {
    state.company = value;
  },
  setProfilePath: (state, path) => {
    state.profile_path = path;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
